import React from 'react';
import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
	CUSTOMER_SERVICE_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import Breadcrumb from '../../breadcrumb/component.tsx';
import { createProjectSettingsUrl } from '../common/create-url/index.tsx';
import messages from './messages.tsx';
import type { ProjectSettingsBreadcrumbPropsWithIntl } from './types.tsx';

const ProjectSettingsBreadcrumb = ({
	children,
	projectKey,
	projectType,
	isSimplified = false,
	intl: { formatMessage },
}: ProjectSettingsBreadcrumbPropsWithIntl) =>
	projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
	(projectType === CORE_PROJECT ||
		projectType === SOFTWARE_PROJECT ||
		projectType === SERVICE_DESK_PROJECT ||
		(projectType === CUSTOMER_SERVICE_PROJECT && fg('jcs_project_type_m3'))) ? (
		<Breadcrumb
			breadcrumb={{
				href: createProjectSettingsUrl(projectKey, projectType, isSimplified),
				text: formatMessage(
					expVal('project-terminology-refresh', 'isEnabled', false)
						? messages.projectSettingsTitleGalaxia
						: messages.projectSettingsTitle,
				),
				type: 'projectSettings',
			}}
		>
			{children}
		</Breadcrumb>
	) : (
		children
	);

export default ProjectSettingsBreadcrumb;
